module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "bg-grayLighter padding10",
    staticStyle: {
      "font-size": "0.875rem"
    }
  }, [_vm._v("Home / demo1")]), _vm._v(" "), _c('h4', {
    staticClass: "margin5"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Panel")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-red align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-reorder",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("New Order")])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-teal align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-cube",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Products")])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-lightBlue align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-commenting-o",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Comments")])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan3 padding5"
  }, [_c('div', {
    staticClass: "padding10 bg-violet align-center fg-white"
  }, [_c('i', {
    staticClass: "fa fa-random",
    staticStyle: {
      "font-size": "3rem"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Bussiness")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "margin5"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Order")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "input-control text",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('input', {
    staticStyle: {
      "padding-right": "58px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table border bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Abby")]), _vm._v(" "), _c('td', [_vm._v("The npm command-line tool is bundled with Node.js")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jasmine")]), _vm._v(" "), _c('td', [_vm._v("Everything you see exists together in a delicate balance")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag alert"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Camille")]), _vm._v(" "), _c('td', [_vm._v("Whatever is worth doing is worth doing well")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag success"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vanessa")]), _vm._v(" "), _c('td', [_vm._v("In love folly is always sweet.")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag info"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Magical")]), _vm._v(" "), _c('td', [_vm._v("The hard part isn’t making the decision. It’s living with it")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "tag warning"
  }, [_vm._v("Javascript")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "square-button mini"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini primary"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "square-button mini danger"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "margin5"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Form")]), _vm._v(" "), _c('div', {
    staticClass: "demo1-form padding10"
  }, [_c('form', {
    staticClass: "flex-grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "cell colspan6"
  }, [_c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan8"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your name"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan8"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your Phone"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan8"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Your email"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sex")]), _vm._v(" "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Male")])]), _vm._v("\n                \n              "), _c('label', {
    staticClass: "input-control radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "gender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('section', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Buy")])]), _vm._v("\n                \n              "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Register")])]), _vm._v("\n                \n              "), _c('label', {
    staticClass: "input-control checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("Ask Info")])])])]), _vm._v(" "), _c('section', {
    staticClass: "cell colspan6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "label cell colspan2"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "cell colspan8"
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "8"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-just-end"
  }, [_c('section', {
    staticClass: "cell colspan2",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('button', {
    staticClass: "button primary"
  }, [_vm._v("Submit")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2db195e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demo1.vue
// module id = 390
// module chunks = 1